import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, IonButton } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { sendSharp } from 'ionicons/icons';
import { PuzzleWinTypesEnum } from '../../puzzle-framework-module/puzzle-win-types.enum';
import { Store } from '@ngxs/store';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { Observable, Subscription } from 'rxjs';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ng2-tooltip-directive-major-angular-updates';

@Component({
  selector: 'lib-app-puzzle-sweepstake-button',
  templateUrl: './puzzle-sweepstake-button.component.html',
  styleUrls: ['./puzzle-sweepstake-button.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon, IonButton, TranslateModule, TooltipModule],
})
export class PuzzleSweepstakeButtonComponent implements OnDestroy {
  private solutionWordFound: boolean;
  private winType: PuzzleWinTypesEnum;
  private solutionWord: string;
  private puzzleSolved: boolean;

  private puzzleIDSubscription: Subscription;
  private puzzleGameSubscription: Subscription;
  private puzzleGame$: Observable<PuzzleGameModel>;

  constructor(private store: Store, private cd: ChangeDetectorRef, private framework: PuzzleFrameworkService) {
    addIcons({ sendSharp });
    this.winType = this.framework.puzzleFrameworkConfig.solutionWordConfig.sweepstake.winType;

    this.puzzleIDSubscription = this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        if (puzzleID === '') {
          return;
        }

        if (this.puzzleGameSubscription) {
          this.puzzleGameSubscription.unsubscribe();
        }

        this.puzzleGame$ = this.store.select(PuzzleGameState.getByID(puzzleID)) as Observable<PuzzleGameModel>;
        this.puzzleGameSubscription = this.puzzleGame$.subscribe((puzzleGame: PuzzleGameModel) => {
          if (!puzzleGame) {
            return;
          }

          if (this.solutionWordFound !== !!puzzleGame.solutionFound) {
            this.solutionWordFound = !!puzzleGame.solutionFound;
          }

          if (this.solutionWord !== puzzleGame.solutionWord) {
            this.solutionWord = puzzleGame.solutionWord;
          }

          if (this.puzzleSolved !== !!puzzleGame.finished) {
            this.puzzleSolved = !!puzzleGame.finished;
          }
        });
      });
  }

  ngOnDestroy(): void {
    if (this.puzzleIDSubscription) {
      this.puzzleIDSubscription.unsubscribe();
    }
    if (this.puzzleGameSubscription) {
      this.puzzleGameSubscription.unsubscribe();
    }
  }

  getSweepstakeTooltip() {
    let tooltip = '';

    if (this.winType === PuzzleWinTypesEnum.SOLUTION_WORD && this.solutionWord) {
      tooltip = this.solutionWordFound
        ? 'PUZZLE.button_bar.buttons.sweepstake.tooltip_solution_word_solved'
        : 'PUZZLE.button_bar.buttons.sweepstake.tooltip_solution_word_unsolved';
    } else {
      tooltip = this.puzzleSolved
        ? 'PUZZLE.button_bar.buttons.sweepstake.tooltip_puzzle_solved'
        : 'PUZZLE.button_bar.buttons.sweepstake.tooltip_puzzle_unsolved';
    }
    return tooltip;
  }

  getSweepstakeState() {
    let solved;

    if (this.winType === PuzzleWinTypesEnum.SOLUTION_WORD && this.solutionWord) {
      solved = this.solutionWordFound;
    } else {
      solved = this.puzzleSolved;
    }

    return solved;
  }

  sendSolutionWord() {
    this.framework.sendSolutionWordData(this.solutionWord);
    this.framework.openPauseDialog();
  }
}
